export const FORM_PLACEHOLDERS = {
  name: "Ex: Sistema de Gestão Veterinária",
  initialDescription:
    "Descreva seu projeto de forma clara e objetiva. Inclua o problema que resolve, principais funcionalidades e objetivos...",
  expandedDescription:
    "A descrição expandida pela IA será exibida aqui após o processamento...",
};

export const FORM_LABELS = {
  name: "Nome do Projeto",
  initialDescription: "Descrição Inicial", 
  expandedDescription: "Descrição Expandida",
};